import './styles.scss';
import * as $ from 'jquery';

export default function featuredVideo() {
  const playButtons = document.querySelectorAll(
    '.def-featured-video__play-button'
  );
  const videoWrapper = document.querySelectorAll('.video-popup-wrapper');
  const videoImage = document.querySelectorAll('.def-featured-video__video');

  // set the min-height for the video image placeholder to be 16/9 ratio
  videoImage.forEach((element) => {
    var width = element.offsetWidth;
    var heightRatio = width * 0.5625 + 'px';
    element.style.minHeight = heightRatio;
  });

  // click play and open the modal
  playButtons.forEach((playButton) => {
    playButton.addEventListener('click', function () {
      // open video modal (next sibling element)
      // use jQuery for fadeIn
      $(`#${playButton.dataset.modalId}`).fadeIn(250);
      // prevent body scrolling
      document.body.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    });
  });

  // click outside video to close modal and stop video playing
  videoWrapper.forEach(function (closeVideo) {
    closeVideo.addEventListener('click', function () {
      $(this).fadeOut(250);
      document.body.style.removeProperty('overflow');
      document.body.classList.remove('modal-open');
      // reset iframe src to pause video on close
      var video = this.querySelector('iframe');
      var videoSrc = this.querySelector('iframe').src;
      video.src = videoSrc;
    });
  });

  // escape key close modal
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key == 'Escape' && document.body.classList.contains('modal-open')) {
      $('.video-popup-wrapper').fadeOut(250);
      document.body.style.removeProperty('overflow');
      document.body.classList.remove('modal-open');
    }
  };
}
